import React from "react"
import Heading from "@amzn/meridian/heading";
import Text from "@amzn/meridian/text";
import {FormattedMessage} from "react-intl";

const PickStatusView = (data) => {
    return (
        <div>
            <div className="overview-fph">
                <Heading level={3} type="h300" alignment="left">
                    <FormattedMessage id={data.pickStatus.title} defaultMessage={data.pickStatus.message}/>
                </Heading>
            </div>
            <Text alignment="left" type="d50">{data.pickStatus.value}</Text>
        </div>
    )
}

export default PickStatusView


// WEBPACK FOOTER //
// ./src/components/pickStatus/PickStatus.js